module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6S5LI"))).then(() => parcelRequire('1iHdE'));